import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ToggleButtonComponent } from './toggle-button.component';
import { DynamicTranslationModule } from '../../dynamic-translation/dynamic-translation.module';

@NgModule({
  imports: [CommonModule, DynamicTranslationModule],
  declarations: [ToggleButtonComponent],
  exports: [ToggleButtonComponent]
})
export class ToggleButtonModule {}
